/**
* @Author: zachalam
* @Date:   2017-01-30T15:49:03-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-30T15:49:03-08:00
*/



import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import JoinS1 from '../components/pages/Join/JoinS1';
import { connect } from 'react-redux';
import { createAccountAction, saveToken } from '../actions/authActions';
import { storeErrors } from '../actions/commonActions';


class JoinS1Container extends Component {

  constructor(props) {
    super(props);

  }


  componentWillMount() {
    let query = this.props.location.query;
    // store URL errors.
    if(query["errors[email][0]"])
    this.props.storeErrors({
      email: `${query["errors[email][0]"]}`,
      username: `${query["errors[username][0]"]}`,
      password: `${query["errors[password][0]"]}`,
      password_confirm: `${query["errors[password_confirm][0]"]}`,
      agreements: `${query["errors[agreements][0]"]}`

    });

    // MT-5013, don't redirect if trying to create an account.
    // create the account and overwrite existing state.
    //if(this.props.authenticated) { browserHistory.push("/search"); }
  }

  render() {
    return (
      <JoinS1 {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.common.errors,
    authenticated: state.auth.isAuthenticated
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    registerUser: (formData) => {
      dispatch(createAccountAction(formData.email,formData.username,
      formData.pass,formData.passConfirm,formData.termsChecked,formData.promoCode,
      formData.ref, formData.referral, formData.radio_code))
        .then((response) => {
          // save jwToken
          dispatch(saveToken(response.data.meta));
          // continue to join-profile
          browserHistory.push("/join-profile");
        })
        .catch((error) => {
          // unable to create account, store errors.
          dispatch(storeErrors(error.response.data));
        });
    },
    storeErrors: (errors) => {
      dispatch(storeErrors(errors))
    }
  };
}

export default connect(mapStateToProps,mapDispatchToProps)(JoinS1Container);



// WEBPACK FOOTER //
// ./src/containers/JoinS1Container.jsx